import {PromotionTracker} from '@aboutyou/grpc-clients/tadarida/aysa_api/features/tracker/v1/tracker.types';
import {TrackPromotions} from '@aboutyou/tracking';
import {
  InfoIconWithLink,
  Image,
  mediaLargeScreens,
  mediaTabletAndUp,
  UnstyledLink,
} from '@aboutyou/ui-components';
import {TrackingPromotionCreative} from '@aboutyou/legacy-tracking-sdk';
import React from 'react';
import styled from 'styled-components';

interface BASTeaserProps {
  image: string;
  target: {url: string; target: string; external: boolean};
  promotionTracking: PromotionTracker;
  fullWidth?: boolean;
  className?: string;
  imageDescription?: string;
  basInfoIconLink?: string;
}

const BAS_IMAGE_MAX_WIDTH = 350;
const BAS_IMAGE_WIDTHS = [BAS_IMAGE_MAX_WIDTH, BAS_IMAGE_MAX_WIDTH * 2];
const BAS_IMAGE_BREAKPOINTS = [
  {breakpoint: mediaTabletAndUp, columns: 2},
  {breakpoint: mediaLargeScreens, columns: 3},
  {columns: 1},
];

export const BASSearchTeaser: React.FC<BASTeaserProps> = ({
  image,
  target,
  promotionTracking,
  fullWidth,
  className,
  imageDescription,
  basInfoIconLink,
}) => {
  return (
    <StyledTrackPromotions
      className={className}
      promotion={{
        source: TrackingPromotionCreative.BasSearch,
        advertisement: {
          id: promotionTracking.promotionId,
          name: promotionTracking.promotionName,
          path: target.url,
        },
      }}
      streamPosition={0}
      triggerOnce
    >
      <AdvertisementWrapper
        data-full-width={fullWidth}
        to={target.url}
        target={target.target}
      >
        <BASImage
          src={image}
          widths={BAS_IMAGE_WIDTHS}
          breakpoints={BAS_IMAGE_BREAKPOINTS}
          disableFixedRatio
          ratio="1:1"
          alt={imageDescription}
        />
        {basInfoIconLink && (
          <InfoIconWithLink to={basInfoIconLink} renderAsAButton />
        )}
      </AdvertisementWrapper>
    </StyledTrackPromotions>
  );
};

const StyledTrackPromotions = styled(TrackPromotions)`
  padding: 15px;
`;

export const AdvertisementWrapper = styled(UnstyledLink)`
  position: relative;
  display: flex;
  width: 100%;
  max-width: ${BAS_IMAGE_MAX_WIDTH}px;

  &[data-full-width='true'] {
    max-width: unset;
  }
`;

export const BASImage = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  border-radius: 3px;
`;
